const getLanguage = (): string => {
  const language = (globalThis?.window?.localStorage?.i18nextLng ||
    'de') as unknown as string;
  return language.split('-')[0];
};

const euroFormatter = new Intl.NumberFormat(getLanguage(), {
  currency: 'EUR',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

const integerFormatter = new Intl.NumberFormat(getLanguage(), {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const palletNumberFormatter = new Intl.NumberFormat(getLanguage(), {
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
});

const ldmNumberFormatter = new Intl.NumberFormat(getLanguage(), {
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat(getLanguage(), {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

const formatPrice = (price: number): string => {
  return euroFormatter.format(price);
};

const formatKG = (weight: number, omitUnit?: boolean) => {
  return `${integerFormatter.format(weight)} ${omitUnit ? '' : 'kg'}`;
};

const formatDistance = (distance: number): string => {
  return integerFormatter.format(distance);
};

const formatKM = (km: number, omitUnit?: boolean): string => {
  return `${formatDistance(km)} ${omitUnit ? '' : 'km'}`;
};

const formatPallets = (num: number): string => {
  return palletNumberFormatter.format(num);
};

const formatLoadingMillimeter = (ldmm: number) => {
  return ldmNumberFormatter.format(ldmm / 1000);
};

const formatLoadingMeter = (ldm: number) => {
  return ldmNumberFormatter.format(ldm);
};

const formatDecimalNumber = (value: number) => {
  return decimalFormatter.format(value);
};

export {
  formatPrice,
  formatKG,
  getLanguage,
  formatKM,
  formatPallets,
  formatLoadingMillimeter,
  formatDecimalNumber,
  formatLoadingMeter,
};
